import React, { useState } from "react";
import Navbar from "../../components/Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useAuthHandling } from '../useAuthhandling';

function Faqadd() {
    let navigate = useNavigate();
    const { isAuthorized, handleUnauthorized } = useAuthHandling();
  
    const tokens = Cookies.get("a_token");
    if (!tokens) {
      navigate("/");
    }
    const [faq, setFaq] = useState({
        faqTitle: "",
        faqBody: "",
      status: true,
    });
    const [formerror, setError] = useState({});
  
    let name, value;
  
    const handleInputs = (e) => {
      console.log(e);
      name = e.target.name;
      value = e.target.value;
      setFaq({ ...faq, [name]: value });
    };
  
   
  
    const validate = (values) => {
      const errors = {};
      if (!values.faqTitle) {
        errors.faqTitle = "Question is required!";
      }
  
      if (!values.faqBody) {
        errors.faqBody = "Answer is required!";
      }
    
      
  
      return errors;
    };
  
    const PostData = async (e) => {
      e.preventDefault();
      const ress = validate(faq);
      setError(ress);
      if (!ress.faqTitle && !ress.faqBody) {
        const res = await fetch(
            `${Config.apiurl}/api/v1/crm/faq/create`,
            {
              method: "POST",
            body: JSON.stringify({
                faqTitle: faq.faqTitle,
                faqBody: faq.faqBody,
                status: faq.status,
              }),
      
              headers: {
                Authorization: `Bearer ${Cookies.get("a_token")}`,
                "Content-type": "application/json; charset=UTF-8",
              },
          })
          if (res.status === 200 ) {
            const data = await res.json();
  
              toast.success("Sucessfully added faq", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              setTimeout(() => navigate("/dashboard"), 3000);
  
              
            } 
            else if(res.status === 401){
              handleUnauthorized();
              PostData();
            }
            else {
              toast.error("Something went wrong", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          
      }
    };
  
    return (
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Faq</h4>
                      <p className="card-description">New Faq</p>
                      <form className="forms-sample" onSubmit={PostData}>
                        {/* <form className="forms-sample"> */}
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Question</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Question"
                            name="faqTitle"
                            value={faq.faqTitle}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.faqTitle}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Answer</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Answer"
                            name="faqBody"
                            value={faq.faqBody}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>{formerror.faqBody}</label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Status</label>
  
                          <select
                            className="form-control"
                            style={{
                              color: "black",
                              backgroundColor: "#2b2e4c;",
                            }}
                            id="exampleInputUsername1"
                            name="status"
                            onChange={handleInputs}
                          >
                            <option
                              id="exampleInputUsername1"
                              name="status"
                              value="true"
                            >
                              true
                            </option>
                            <option
                              id="exampleInputUsername1"
                              name="status"
                              value="false"
                            >
                              false
                            </option>
                          </select>
                        </div>
  
                    
                        <button
                          type="submit"
                          onClick={PostData}
                          className="btn btn-primary me-2"
                        >
                          Submit
                        </button>
                        <ToastContainer />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

export default Faqadd
